import './villavenezia/style';
import FormStructure from './villavenezia/form_structure';

export default FormStructure;